module.exports = __webpack_public_path__ + "img/coffee.6c3eb1e4.jpg";